import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNotificationsRouteIntegration } from '../contexts/NotificationsContext';

// Inner component that's only rendered when we're confident we're in a Router context
const RouterAwareHandler = () => {
  const location = useLocation();
  const { handleRouteChange } = useNotificationsRouteIntegration();
  
  React.useEffect(() => {
    if (handleRouteChange && location) {
      try {
        handleRouteChange(location.pathname);
      } catch (error) {
        console.error('Error in RouteChangeHandler:', error);
      }
    }
  }, [location?.pathname, handleRouteChange]);
  
  return null;
};

// This is a wrapper component that doesn't render the inner component if we detect
// it's not in a Router context (like in tests or certain SSR scenarios)
const RouteChangeHandler = () => {
  // We can't directly check if we're in a Router context, but we can put the 
  // RouterAwareHandler inside an error boundary to catch errors
  const [isInRouter, setIsInRouter] = React.useState(true);
  
  React.useEffect(() => {
    // This effect is used to detect Router context errors after mounting
    return () => {
      // Cleanup function does nothing, just ensures the effect runs once
    };
  }, []);
  
  // If we know we're not in a Router context, don't render the inner component
  if (!isInRouter) {
    return null;
  }
  
  // Use try/catch pattern only for rendering
  try {
    return <RouterAwareHandler />;
  } catch (error) {
    // If we get an error during render, we're not in a Router context
    console.warn('RouteChangeHandler: Not in a Router context, disabling');
    setIsInRouter(false);
    return null;
  }
};

export default RouteChangeHandler; 